import { AccountFragment, SubscriptionStatus } from 'src/graphql'
import { ADDON_PACKAGES } from 'src/marketing/plans/constants'
import { hasNotLimitedPlan } from 'src/helpers'

// return true is user has active or trialing non-limited subscription
// and has system package or elite package (for now)
const isEliteUser = (account: AccountFragment): boolean => {
  const subscriptions = account.subscriptions
  if (!subscriptions) {
    return false
  }
  const hasPlan = hasNotLimitedPlan(subscriptions)
  const hasAddonPackage = subscriptions.some(
    s =>
      (s.status === SubscriptionStatus.ACTIVE ||
        s.status === SubscriptionStatus.TRIALING) &&
      ADDON_PACKAGES.includes(s.sku),
  )
  return hasPlan && hasAddonPackage
}

export default isEliteUser
